export default {
    title: '通过两个步骤将图标添加到桌面',
    step1: '下载文件，然后点击【允许】',
    download: '下载文件',
    step2: '进入【设置】页面，点击进入已下载的描述文件，点击右上方【安装】',
    setting: '进入设置页面',

    style2_step1: '下载描述文件，点击【允许】',
    style2_continue: '继续下一步',
}